import { render, staticRenderFns } from "./exhibition_account.vue?vue&type=template&id=43772678&scoped=true&"
import script from "./exhibition_account.vue?vue&type=script&lang=js&"
export * from "./exhibition_account.vue?vue&type=script&lang=js&"
import style0 from "./exhibition_account.vue?vue&type=style&index=0&id=43772678&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43772678",
  null
  
)

export default component.exports